import axios from "axios";
import Cookies from "js-cookie";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 50000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(async function (config) {
  let adminInfo = localStorage.getItem("authkey") || null;

  const loginData = {
    username: "Chat Panel",
    password: "Chat@123",
  };
  

  const getAuthKey = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/login`,
        loginData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data.status) {
        const { key } = response.data;
        localStorage.setItem("authkey", key);
        return key; 
      } else {
        console.error("Login failed:", response.data.message);
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  let company;

  if (Cookies.get("company")) {
    company = Cookies.get("company");
  }
  if (!adminInfo) {
    adminInfo = await getAuthKey(); 
  }

  if (!adminInfo) {
    throw new Error("Authorization failed: Unable to retrieve auth key");
  }

  return {
    ...config,
    headers: {
      authorization: `Bearer ${adminInfo}`,
      company: company,
    },
  };
});

const responseBody = (response) => response.data;

const requests = {
  get: (url, body, headers) =>
    instance.get(url, body, headers).then(responseBody),

  post: (url, body) => instance.post(url, body).then(responseBody),

  put: (url, body, headers) =>
    instance.put(url, body, headers).then(responseBody),

  patch: (url, body) => instance.patch(url, body).then(responseBody),

  delete: (url, body) => instance.delete(url, body).then(responseBody),
};

export default requests;
